import { render, staticRenderFns } from "./OpenClientAccount.vue?vue&type=template&id=350b7f2c&"
import script from "./OpenClientAccount.vue?vue&type=script&lang=js&"
export * from "./OpenClientAccount.vue?vue&type=script&lang=js&"
import style0 from "./OpenClientAccount.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports